import { CATEGORY_ICON } from "../lib/meta";
import { Plane, Phone, User, Ticket, Clock } from "lucide-react";

export default function ItineraryTimeline({ itinerary }) {
  if (!itinerary) return null;
  const { pickup, days } = itinerary;
  return (
    <div data-testid="itinerary-timeline">
      {pickup && (
        <div className="rounded-xl bg-rr-forest/60 border border-rr-gold/20 p-7 md:p-9 mb-12" data-testid="pickup-card">
          <div className="flex items-center gap-3 mb-5">
            <Plane className="w-5 h-5 text-rr-gold" strokeWidth={1.4} /><span className="overline">Your Arrival</span>
          </div>
          <p className="font-heading text-2xl md:text-3xl text-rr-ivory mb-2">{pickup.airport}</p>
          <p className="text-rr-ivory/65 text-sm leading-relaxed mb-6 max-w-2xl">{pickup.transfer_note}</p>
          <div className="grid sm:grid-cols-2 gap-5 text-sm">
            <Detail icon={Clock} label="Pickup time" value={pickup.pickup_time} />
            <Detail icon={Ticket} label="Flight" value={pickup.flight_number || "Awaiting your flight details"} />
            <Detail icon={User} label="Chauffeur" value={pickup.driver_name || "To be assigned"} />
            <Detail icon={Phone} label="Driver contact" value={pickup.driver_phone || "Shared before arrival"} />
          </div>
          <p className="text-xs text-rr-ivory/40 mt-6">{pickup.meeting_point}</p>
        </div>
      )}
      <div className="relative pl-7 md:pl-9 border-l border-rr-gold/40 space-y-14">
        {days?.map((day, di) => (
          <div key={di} className="relative fade-up" style={{ animationDelay: `${di * 60}ms` }} data-testid={`itinerary-day-${day.day}`}>
            <div className="absolute -left-[35px] md:-left-[43px] top-1 w-3.5 h-3.5 rounded-full bg-rr-gold ring-4 ring-rr-bg" />
            <span className="overline">Day {day.day}{day.date_label ? ` · ${day.date_label}` : ""}</span>
            <h4 className="font-heading text-3xl md:text-4xl text-rr-ivory mt-1.5 mb-6">{day.title}</h4>
            <div className="space-y-6">
              {day.blocks?.map((b, bi) => {
                const Icon = CATEGORY_ICON[b.category] || CATEGORY_ICON.default;
                return (
                  <div key={bi} className="flex gap-4">
                    <div className="w-9 h-9 rounded-full bg-rr-surface flex items-center justify-center shrink-0 mt-0.5">
                      <Icon className="w-4 h-4 text-rr-gold" strokeWidth={1.4} />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-baseline gap-3 flex-wrap">
                        <span className="font-body text-xs text-rr-gold tracking-wide font-semibold">{b.time}</span>
                        <span className="font-body text-base text-rr-ivory">{b.title}</span>
                      </div>
                      <p className="text-sm text-rr-muted leading-relaxed mt-1">{b.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Detail({ icon: Icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <Icon className="w-4 h-4 text-rr-gold/70 mt-1 shrink-0" strokeWidth={1.4} />
      <div>
        <p className="text-[10px] text-rr-ivory/45 uppercase tracking-[0.18em]">{label}</p>
        <p className="text-rr-ivory">{value}</p>
      </div>
    </div>
  );
}
